import React from 'react';

import Menu from '../engine/FormBuilderMenuEngine';

import styled from 'styled-components/macro';
import Animation from '../Animation';
import FormBuilderIntegrations from '../../internal-components/form-builder/engine/FormBuilderIntegrationsEngine';
import FormBuilderTemplate from '../../internal-components/form-builder/FormBuilderTemplate';
import FormBuilderReminders from '../../internal-components/form-builder/engine/FormBuilderRemindersEngine';
import FormBuilderNotifications from '../../internal-components/form-builder/engine/FormBuilderNotificationsEngine';
import FormBuilderCollaborate from '../../internal-components/form-builder/engine/FormBuilderCollaborateEngine';
import FormBuilderAutomations from '../engine/FormBuilderAutomationsEngine';
import FormBuilderStatuses from '../engine/FormBuilderStatusesEngine';
import FormBuilderEdit from '../../internal-components/form-builder/FormBuilderEdit';
import Loader from '../Loader';
import { UPDATE_FORM } from '../../store/modules/state/formBuilder';
import FormBuilderOverviewDialogEngine from '../engine/FormBuilderOverviewDialogEngine';
import FormBuilderShareEngine from '../engine/FormBuilderShareEngine';

const Container = styled.div`
  margin: 0 -60px -36px;
  display: flex;
  overflow-y: scroll;
`;

const Content = styled.div`
  transition: 0.5s;
  width: 100%;
  padding-left: ${({ menuWidth }) => menuWidth + 40 + 'px'};
  overflow-y: scroll;
`;

const FormBuilderView = ({
  formId,
  sharingType,
  isNew,
  dispatch,
  autosave,
  form,
  pageId,
  hasEntries,
  adminFields,
  rules,
  setRules,
  reminders,
  setReminders,
  allLookupDependencies,
  currentStage,
  setCurrentStage,
  startingFolder,
  currentFolder,
  setCurrentFolder,
  reloadForm,
  ...props
}) => {
  return (
    <>
      <Loader isLoading={!form} />
      <Container>
        <Menu
          currentStage={currentStage}
          setCurrentStage={setCurrentStage}
          onExpand={props.setMenuWidth}
          onCollapse={props.setMenuWidth}
          sharingType={form ? form.sharingType : null}
          currentFolder={currentFolder}
        />
        <FormBuilderOverviewDialogEngine
          isOpen={props.isOverviewDialogOpen}
          setIsOpen={props.setIsOverviewDialogOpen}
          isNew={isNew}
          startingFolder={startingFolder}
          setCurrentFolder={setCurrentFolder}
          form={form}
          previousLocation={props.previousLocation}
          // dispatch?
          // updtae form ?
        />
        {!form || !Object.keys(form).length ? null : (
          <Content menuWidth={props.menuWidth}>
            <Animation
              appear
              in={'edit' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderEdit
                form={form}
                formId={formId}
                rules={rules}
                setRules={setRules}
                reminders={reminders}
                setReminders={setReminders}
                allLookupDependencies={allLookupDependencies}
                autosave={autosave}
                hasEntries={hasEntries}
                currentFolder={currentFolder}
                setIsOverviewDialogOpen={props.setIsOverviewDialogOpen}
              />
            </Animation>
            <Animation
              appear
              in={'statuses' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderStatuses
                form={form}
                formId={formId}
                updateStatusesOnRedux={statusesArray =>
                  dispatch({
                    type: UPDATE_FORM,
                    payload: { ...form, customStatuses: statusesArray }
                  })
                }
              />
            </Animation>
            <Animation
              appear
              in={'automations' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderAutomations
                form={form}
                formId={formId}
                updateAutomationsOnRedux={automations =>
                  dispatch({
                    type: UPDATE_FORM,
                    payload: { ...form, automations }
                  })
                }
              />
            </Animation>
            <Animation
              appear
              in={'collaborate' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderCollaborate
                {...{
                  formId,
                  form,
                  autosave,
                  pageId,
                  reloadForm
                }}
              />
            </Animation>
            <Animation
              appear
              in={'reminders' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderReminders
                {...{
                  formId,
                  form
                }}
              />
            </Animation>
            <Animation
              appear
              in={'integrations' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderIntegrations
                {...{
                  formId,
                  form,
                  dispatch
                }}
              />
            </Animation>
            <Animation
              appear
              in={'notifications' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderNotifications
                {...{
                  formId,
                  form
                }}
              />
            </Animation>
            <Animation
              appear
              in={'share' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderShareEngine
                {...{
                  formId,
                  form,
                  pageId
                }}
              />
            </Animation>
            <Animation
              appear
              in={'template' === currentStage}
              mountOnEnter
              unmountOnExit
            >
              <FormBuilderTemplate
                {...{
                  formId,
                  form,
                  dispatch
                }}
              />
            </Animation>
          </Content>
        )}
        <span form-id={formId} /> {/* for automation */}
      </Container>
    </>
  );
};

export default FormBuilderView;
